module.exports = __webpack_public_path__ + "img/frederiksoord.bd5f7524.webp";